




































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import {
  AdminContentItemSendToReviewUseCase
} from '@/modules/content-item/use-cases/admin/admin-content-item-send-to-review.use-case'
import { Prop } from 'vue-property-decorator'
import { ContentItemSendToReviewRequestModel } from '@/modules/content-item/models/content-item-request.model'

@Component({
  components: {
    BaseButton,
    Modal,
    BaseInput,
    Toggle
  }
})
export default class AdminContentItemSendToReview extends Vue {
  constructor(
    private readonly sendToReviewUC: AdminContentItemSendToReviewUseCase
  ) {
    super()
  }

  showDialog = false

  @Prop({ required: true }) contentItemId!: number
  @Prop() reviewReason?: string
  @Prop({ default: 'ارسال برای بازبینی' }) label?: string

  private requestData: Omit<ContentItemSendToReviewRequestModel, 'status'> = {
    review_reason: this.reviewReason,
    notify_to_user: true
  }

  onSubmit() {
    this.sendToReviewUC.execute(this.contentItemId, this.requestData)
      .then(() => {
        if (this.sendToReviewUC.isSuccess) {
          this.showDialog = false
        }
      })
  }
}
